import { useState } from 'react'
import type { ImportSummary } from '../api/types'
import { useImportFeed } from '../hooks/useShows'
import { Button, ErrorNote, Field } from './ui'

/** Bring a show over from another podcast host by its RSS feed. */
export function ImportForm({ workspaceId, onDone }: { workspaceId: string; onDone: (summary: ImportSummary) => void }) {
  const [url, setUrl] = useState('')
  const [limit, setLimit] = useState(20)
  const importFeed = useImportFeed(workspaceId)
  return (
    <form
      className="stack"
      onSubmit={(event) => {
        event.preventDefault()
        importFeed.mutate({ feed_url: url.trim(), limit }, { onSuccess: onDone })
      }}
    >
      <Field label="Feed URL" hint="Your show's RSS feed on its current host.">
        <input type="url" value={url} onChange={(event) => setUrl(event.target.value)} placeholder="https://feeds.example.com/my-show.xml" required />
      </Field>
      <Field label="Episodes" hint="The newest episodes to bring over, up to 100. Import the same feed again later to add more.">
        <input className="input-narrow" type="number" min={1} max={100} value={limit} onChange={(event) => setLimit(Number(event.target.value) || 20)} />
      </Field>
      <p className="muted small">
        Each file is copied and processed like an upload. Nothing is transcribed or published until you choose, and publishing keeps each episode's
        original date.
      </p>
      {importFeed.error && <ErrorNote error={importFeed.error} />}
      <div className="row">
        <Button type="submit" busy={importFeed.isPending} disabled={!url.trim()}>
          Import
        </Button>
      </div>
    </form>
  )
}
